<template>
  <div
    :class="`ims-toast ${visible ? 'visible' : 'hidden'}`"
    @click="click()"
  >
    <div class="toast-wrapper">
      <ims-icon
        v-if="$store.state.interact.toast.icon"
        :icon="$store.state.interact.toast.icon"
      />
      <label>{{ $store.state.interact.toast.title }}</label>
    </div>
  </div>
</template>

<script>
import tick from '../../modules/tick/tick';
export default {
  methods: {
    click() {
      if (this.$store.state.interact.toast.click) {
        this.$store.state.interact.toast.click();
      }
      this.$store.dispatch('interact/toast/hide');
    }
  },
  watch: {
    '$store.state.interact.toast.show'(show) {
      if (show) {
        // wait for 2000 ms then close it
        tick(this.$store.state.interact.toast.timeout).then(() => {
          this.$store.dispatch('interact/toast/hide');
        });
      }
    }
  },
  computed: {
    visible() {
      return this.$store.state.interact.toast.show;
    }
  }
};
</script>

<style lang="scss">
@import '../../scss/utils/variables';

.ims-toast {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 2000;
  transition: all 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  &.visible {
    opacity: 1;
    bottom: 20px;
  }
  &.hidden {
    opacity: 0;
    pointer-events: none;
    transform: translateY(200px);
    bottom: 0;
  }
  .toast-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    height: 40px;
    border-radius: 3px;
    background-color: darken($primary, 20%);
    color: #fff;
    box-shadow: 0px 10px 20px -3px rgba(0, 0, 0, 0.3);
    color: #000;
    max-width: 300px;
    width: auto;
    min-width: 300px;
    min-height: 30px;
    padding: 10px 20px;

    .ims-icon {
      margin-right: 10px;
    }

    label {
      color: #fff;
      margin: 0;
      line-height: 100%;
      padding: 0;
      font-size: 0.9rem;
      line-height: 1rem;
    }
  }
}
</style>
